import { Tag, type TagProps } from '../../../tag/tag.tsx'
import { useCardContext } from '../../use-card.ts'

export type CardHeadingTagProps = TagProps

export const CardHeadingTag = (props: CardHeadingTagProps) => {
  const { scale } = useCardContext()
  return <Tag {...props} size={scale === 'sm' ? 'sm' : 'md'} />
}
